import { api } from "@/redux/api";

import {
	MsdynamicsFieldsResponse,
	MsdynamicsFieldsResponseSchema,
} from "@/pages/Private/pages/Company/schema/dynamics";

/**
 * The `campaignresponse` attributes of the connected environment, the targets of the campaign
 * response mappings (PREC-4367). Beside `dynamics.api.ts`, whose "Dynamics" cache tag it shares.
 */
export const dynamicsCampaignResponseApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getDynamicsCampaignResponseFields: builder.query<MsdynamicsFieldsResponse, void>({
			query: () => ({
				url: "msdynamics/fields/campaign-responses",
				method: "GET",
				responseSchema: MsdynamicsFieldsResponseSchema,
			}),
			providesTags: ["Dynamics"],
		}),
	}),
});

export const { useGetDynamicsCampaignResponseFieldsQuery } = dynamicsCampaignResponseApi;
